export default "__VITE_ASSET__CQ4Z4EP0__"